// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    fapiPublicGetV1Ping (params?: {}): Promise<Dict>;
    fapiPublicGetV3Ping (params?: {}): Promise<Dict>;
    fapiPublicGetV1Time (params?: {}): Promise<Dict>;
    fapiPublicGetV3Time (params?: {}): Promise<Dict>;
    fapiPublicGetV1ExchangeInfo (params?: {}): Promise<Dict>;
    fapiPublicGetV3ExchangeInfo (params?: {}): Promise<Dict>;
    fapiPublicGetV1Depth (params?: {}): Promise<Dict>;
    fapiPublicGetV3Depth (params?: {}): Promise<Dict>;
    fapiPublicGetV1Trades (params?: {}): Promise<List>;
    fapiPublicGetV3Trades (params?: {}): Promise<List>;
    fapiPublicGetV1HistoricalTrades (params?: {}): Promise<List>;
    fapiPublicGetV3HistoricalTrades (params?: {}): Promise<List>;
    fapiPublicGetV1AggTrades (params?: {}): Promise<List>;
    fapiPublicGetV3AggTrades (params?: {}): Promise<List>;
    fapiPublicGetV1Klines (params?: {}): Promise<List>;
    fapiPublicGetV3Klines (params?: {}): Promise<List>;
    fapiPublicGetV1IndexPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetV3IndexPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetV1MarkPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetV3MarkPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetV1PremiumIndex (params?: {}): Promise<Dict>;
    fapiPublicGetV3PremiumIndex (params?: {}): Promise<Dict | List>;
    fapiPublicGetV1FundingRate (params?: {}): Promise<List>;
    fapiPublicGetV3FundingRate (params?: {}): Promise<List>;
    fapiPublicGetV1FundingInfo (params?: {}): Promise<List>;
    fapiPublicGetV3FundingInfo (params?: {}): Promise<List>;
    fapiPublicGetV1Ticker24hr (params?: {}): Promise<List>;
    fapiPublicGetV3Ticker24hr (params?: {}): Promise<Dict | List>;
    fapiPublicGetV1TickerPrice (params?: {}): Promise<List>;
    fapiPublicGetV3TickerPrice (params?: {}): Promise<List>;
    fapiPublicGetV1TickerBookTicker (params?: {}): Promise<List>;
    fapiPublicGetV3TickerBookTicker (params?: {}): Promise<List>;
    fapiPublicGetV1AdlQuantile (params?: {}): Promise<List>;
    fapiPublicGetV1ForceOrders (params?: {}): Promise<List>;
    fapiPublicGetV3Indexreferences (params?: {}): Promise<Dict>;
    fapiPrivateGetV1PositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivateGetV3PositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivateGetV1MultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivateGetV3MultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivateGetV1Order (params?: {}): Promise<Dict>;
    fapiPrivateGetV3Order (params?: {}): Promise<Dict>;
    fapiPrivateGetV1OpenOrder (params?: {}): Promise<Dict>;
    fapiPrivateGetV3OpenOrder (params?: {}): Promise<Dict>;
    fapiPrivateGetV1OpenOrders (params?: {}): Promise<List>;
    fapiPrivateGetV3OpenOrders (params?: {}): Promise<List>;
    fapiPrivateGetV1AllOrders (params?: {}): Promise<List>;
    fapiPrivateGetV3AllOrders (params?: {}): Promise<List>;
    fapiPrivateGetV2Balance (params?: {}): Promise<List>;
    fapiPrivateGetV3Balance (params?: {}): Promise<List>;
    fapiPrivateGetV3Account (params?: {}): Promise<Dict>;
    fapiPrivateGetV1PositionMarginHistory (params?: {}): Promise<List>;
    fapiPrivateGetV3PositionMarginHistory (params?: {}): Promise<List>;
    fapiPrivateGetV2PositionRisk (params?: {}): Promise<List>;
    fapiPrivateGetV3PositionRisk (params?: {}): Promise<List>;
    fapiPrivateGetV1UserTrades (params?: {}): Promise<List>;
    fapiPrivateGetV3UserTrades (params?: {}): Promise<List>;
    fapiPrivateGetV1Income (params?: {}): Promise<List>;
    fapiPrivateGetV3Income (params?: {}): Promise<List>;
    fapiPrivateGetV1LeverageBracket (params?: {}): Promise<List>;
    fapiPrivateGetV3LeverageBracket (params?: {}): Promise<List>;
    fapiPrivateGetV1CommissionRate (params?: {}): Promise<Dict>;
    fapiPrivateGetV3CommissionRate (params?: {}): Promise<Dict>;
    fapiPrivateGetV3AdlQuantile (params?: {}): Promise<List>;
    fapiPrivateGetV3ForceOrders (params?: {}): Promise<List>;
    fapiPrivateGetV3Mmp (params?: {}): Promise<List>;
    fapiPrivateGetV3AccountWithJoinMargin (params?: {}): Promise<Dict>;
    fapiPrivateGetV4Account (params?: {}): Promise<Dict>;
    fapiPrivateGetV3Agent (params?: {}): Promise<List>;
    fapiPrivateGetV3Builder (params?: {}): Promise<List>;
    fapiPrivatePostV1PositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivatePostV3PositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivatePostV1MultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostV3MultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostV1Order (params?: {}): Promise<Dict>;
    fapiPrivatePostV3Order (params?: {}): Promise<Dict>;
    fapiPrivatePostV1OrderTest (params?: {}): Promise<Dict>;
    fapiPrivatePostV3OrderTest (params?: {}): Promise<Dict>;
    fapiPrivatePostV1BatchOrders (params?: {}): Promise<List>;
    fapiPrivatePostV3BatchOrders (params?: {}): Promise<List>;
    fapiPrivatePostV1AssetWalletTransfer (params?: {}): Promise<Dict>;
    fapiPrivatePostV3AssetWalletTransfer (params?: {}): Promise<Dict>;
    fapiPrivatePostV1CountdownCancelAll (params?: {}): Promise<Dict>;
    fapiPrivatePostV3CountdownCancelAll (params?: {}): Promise<Dict>;
    fapiPrivatePostV1Leverage (params?: {}): Promise<Dict>;
    fapiPrivatePostV3Leverage (params?: {}): Promise<Dict>;
    fapiPrivatePostV1MarginType (params?: {}): Promise<Dict>;
    fapiPrivatePostV3MarginType (params?: {}): Promise<Dict>;
    fapiPrivatePostV1PositionMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostV3PositionMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostV1ListenKey (params?: {}): Promise<Dict>;
    fapiPrivatePostV3ListenKey (params?: {}): Promise<Dict>;
    fapiPrivatePostV3Mmp (params?: {}): Promise<List>;
    fapiPrivatePostV3MmpReset (params?: {}): Promise<Dict>;
    fapiPrivatePostV3Noop (params?: {}): Promise<Dict>;
    fapiPrivatePostV3ApproveAgent (params?: {}): Promise<Dict>;
    fapiPrivatePostV3UpdateAgent (params?: {}): Promise<Dict>;
    fapiPrivatePostV3ApproveBuilder (params?: {}): Promise<Dict>;
    fapiPrivatePostV3UpdateBuilder (params?: {}): Promise<Dict>;
    fapiPrivatePutV1ListenKey (params?: {}): Promise<Dict>;
    fapiPrivatePutV3ListenKey (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV1Order (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV3Order (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV1AllOpenOrders (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV3AllOpenOrders (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV1BatchOrders (params?: {}): Promise<List>;
    fapiPrivateDeleteV3BatchOrders (params?: {}): Promise<List>;
    fapiPrivateDeleteV3Mmp (params?: {}): Promise<List>;
    fapiPrivateDeleteV1ListenKey (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV3ListenKey (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV3Agent (params?: {}): Promise<Dict>;
    fapiPrivateDeleteV3Builder (params?: {}): Promise<Dict>;
    sapiPublicGetV1Ping (params?: {}): Promise<Dict>;
    sapiPublicGetV1Time (params?: {}): Promise<Dict>;
    sapiPublicGetV1ExchangeInfo (params?: {}): Promise<Dict>;
    sapiPublicGetV1Depth (params?: {}): Promise<Dict>;
    sapiPublicGetV1Trades (params?: {}): Promise<List>;
    sapiPublicGetV1HistoricalTrades (params?: {}): Promise<List>;
    sapiPublicGetV1AggTrades (params?: {}): Promise<List>;
    sapiPublicGetV1Klines (params?: {}): Promise<List>;
    sapiPublicGetV1Ticker24hr (params?: {}): Promise<List>;
    sapiPublicGetV1TickerPrice (params?: {}): Promise<List>;
    sapiPublicGetV1TickerBookTicker (params?: {}): Promise<List>;
    sapiPublicGetV1AsterWithdrawEstimateFee (params?: {}): Promise<Dict>;
    sapiPublicGetV3Ping (params?: {}): Promise<Dict>;
    sapiPublicGetV3Time (params?: {}): Promise<Dict>;
    sapiPublicGetV3ExchangeInfo (params?: {}): Promise<Dict>;
    sapiPublicGetV3Depth (params?: {}): Promise<Dict>;
    sapiPublicGetV3Trades (params?: {}): Promise<List>;
    sapiPublicGetV3HistoricalTrades (params?: {}): Promise<List>;
    sapiPublicGetV3AggTrades (params?: {}): Promise<List>;
    sapiPublicGetV3Klines (params?: {}): Promise<List>;
    sapiPublicGetV3Ticker24hr (params?: {}): Promise<Dict | List>;
    sapiPublicGetV3TickerPrice (params?: {}): Promise<List>;
    sapiPublicGetV3TickerBookTicker (params?: {}): Promise<List>;
    sapiPublicGetV3AsterWithdrawEstimateFee (params?: {}): Promise<Dict>;
    sapiPrivateGetV1CommissionRate (params?: {}): Promise<Dict>;
    sapiPrivateGetV1Order (params?: {}): Promise<Dict>;
    sapiPrivateGetV1OpenOrders (params?: {}): Promise<List>;
    sapiPrivateGetV1AllOrders (params?: {}): Promise<List>;
    sapiPrivateGetV1TransactionHistory (params?: {}): Promise<List>;
    sapiPrivateGetV1Account (params?: {}): Promise<Dict>;
    sapiPrivateGetV1UserTrades (params?: {}): Promise<List>;
    sapiPrivateGetV3CommissionRate (params?: {}): Promise<Dict>;
    sapiPrivateGetV3Order (params?: {}): Promise<Dict>;
    sapiPrivateGetV3OpenOrders (params?: {}): Promise<List>;
    sapiPrivateGetV3AllOrders (params?: {}): Promise<List>;
    sapiPrivateGetV3Account (params?: {}): Promise<Dict>;
    sapiPrivateGetV3UserTrades (params?: {}): Promise<List>;
    sapiPrivateGetV3OpenOrder (params?: {}): Promise<Dict>;
    sapiPrivatePostV1Order (params?: {}): Promise<Dict>;
    sapiPrivatePostV1AssetWalletTransfer (params?: {}): Promise<Dict>;
    sapiPrivatePostV1AssetSendToAddress (params?: {}): Promise<Dict>;
    sapiPrivatePostV1ListenKey (params?: {}): Promise<Dict>;
    sapiPrivatePostV3Order (params?: {}): Promise<Dict>;
    sapiPrivatePostV3AssetWalletTransfer (params?: {}): Promise<Dict>;
    sapiPrivatePostV3AsterUserWithdraw (params?: {}): Promise<Dict>;
    sapiPrivatePostV3ListenKey (params?: {}): Promise<Dict>;
    sapiPrivatePutV1ListenKey (params?: {}): Promise<Dict>;
    sapiPrivatePutV3ListenKey (params?: {}): Promise<Dict>;
    sapiPrivateDeleteV1Order (params?: {}): Promise<Dict>;
    sapiPrivateDeleteV1AllOpenOrders (params?: {}): Promise<Dict>;
    sapiPrivateDeleteV1ListenKey (params?: {}): Promise<Dict>;
    sapiPrivateDeleteV3AllOpenOrders (params?: {}): Promise<List>;
    sapiPrivateDeleteV3Order (params?: {}): Promise<Dict>;
    sapiPrivateDeleteV3ListenKey (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
